import { render, staticRenderFns } from "./DeliverySlotExceptions.vue?vue&type=template&id=c118fa9e"
import script from "./DeliverySlotExceptions.vue?vue&type=script&lang=js"
export * from "./DeliverySlotExceptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports